import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./Themes/ThemeContext";
import NavbarComponent from "./Navbar/Navbar";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Services from "./Pages/Services";
import FAQ from "./Pages/FAQ";
import Blog from "./Pages/Blog";
import Contact from "./Pages/Contact";
import GetStarted from "./Pages/GetStarted";
import PricingPage from "./Pages/PricingPage";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import "./App.css";
import Static from "./Home/Templates/Static";
import TermsConditions from "./Footer/TermsConditions";
import PrivacyPolicy from "./Footer/PrivacyPolicy";
import RefundCancellation from "./Footer/RefundCancellation";
import ShipmentAndBilling from "./Footer/ShipmentAndBilling";
import Dynamic from "./Home/Templates/Dynamic";
import Personalised from "./Home/Templates/Personalised";
import Responsive from "./Home/Templates/Responsive";
import Card1 from "../src/Pages/card1.jsx";
import FloatingCTA from "./components/FloatingCTA";
import LeadPopup from "./components/LeadPopup";
import StickyCTABar from "./components/StickyCTABar";

const App = () => {
  return (
    <ThemeProvider>
      <Router>
        <NavbarComponent />
        <TransitionGroup className="transition-group">
          <Routes>
            <Route path="/" element={<CSSTransition timeout={500} classNames="fade" key="home"><Home /></CSSTransition>} />
            <Route path="/about" element={<CSSTransition timeout={500} classNames="fade" key="about"><About /></CSSTransition>} />
            <Route path="/services" element={<CSSTransition timeout={500} classNames="fade" key="services"><Services /></CSSTransition>} />
            <Route path="/faq" element={<CSSTransition timeout={500} classNames="fade" key="faq"><FAQ /></CSSTransition>} />
            <Route path="/blog" element={<CSSTransition timeout={500} classNames="fade" key="blog"><Blog /></CSSTransition>} />
            <Route path="/contact" element={<CSSTransition timeout={500} classNames="fade" key="contact"><Contact /></CSSTransition>} />
            <Route path="/get-started" element={<CSSTransition timeout={500} classNames="fade" key="get-started"><GetStarted /></CSSTransition>} />
            <Route path="/pricing" element={<CSSTransition timeout={500} classNames="fade" key="pricing"><PricingPage /></CSSTransition>} />
            <Route path="/static" element={<CSSTransition timeout={500} classNames="fade" key="static"><Static /></CSSTransition>} />
            <Route path="/dynamic" element={<CSSTransition timeout={500} classNames="fade" key="dynamic"><Dynamic /></CSSTransition>} />
            <Route path="/personalised" element={<CSSTransition timeout={500} classNames="fade" key="personalised"><Personalised /></CSSTransition>} />
            <Route path="/responsive" element={<CSSTransition timeout={500} classNames="fade" key="responsive"><Responsive /></CSSTransition>} />
            <Route path="/terms-conditions" element={<CSSTransition timeout={500} classNames="fade" key="terms"><TermsConditions /></CSSTransition>} />
            <Route path="/privacy-policy" element={<CSSTransition timeout={500} classNames="fade" key="privacy"><PrivacyPolicy /></CSSTransition>} />
            <Route path="/refund-cancellation" element={<CSSTransition timeout={500} classNames="fade" key="refund"><RefundCancellation /></CSSTransition>} />
            <Route path="/shipment-billing" element={<CSSTransition timeout={500} classNames="fade" key="shipment"><ShipmentAndBilling /></CSSTransition>} />
            <Route path="/page/:pageNumber" element={<Blog />} />
            <Route path="/blog/:id" element={<Card1 />} />
          </Routes>
        </TransitionGroup>
        <FloatingCTA />
        <LeadPopup />
        <StickyCTABar />
      </Router>
    </ThemeProvider>
  );
};

export default App;
